module.exports = __webpack_public_path__ + "img/icon-address.3b284921.svg";